import Icon from 'veui/components/Icon'
import { IconTrendPages } from 'dls-icons-vue'

Icon.register('trend-pages', IconTrendPages)
